import {isGooglePayInPaymentsOptionList} from '../../selectors/PaymentOptionSelectors/PaymentOptionSelectors';
import DomUtils from '../../utils/DomUtils';
import * as types from '../action-types';
import isApplePayInPaymentList from './applePay/isApplePayInPaymentList';
import setApplePayAvailable from './applePay/setApplePayAvailable';
import {onGooglePayLoaded} from './googlePayActions';

export const setPaymentOptions = paymentOptions => ({
  type: types.SET_PAYMENT_OPTIONS,
  options: paymentOptions,
});

export const addPaymentOptions = (paymentOptions, optionTypeToRemove = null) => ({
  type: types.ADD_PAYMENT_OPTIONS_TO_STATE,
  options: paymentOptions,
  optionTypeToRemove,
});

export const setPaymentOptionErrorMessage = (paymentOptionIndex, errorMessage) => ({
  type: types.SET_PAYMENT_OPTION_ERROR_MESSAGE,
  paymentOptionIndex,
  errorMessage,
});

export const setTranslatedPaymentOptionErrorMessage = (paymentOptionIndex, translatedErrorMessage) => ({
  type: types.SET_TRANSLATED_PAYMENT_OPTION_ERROR_MESSAGE,
  paymentOptionIndex,
  translatedErrorMessage,
});

export const updateNewCardDetails = (newCardProperty, propertyValue) => {
  let formattedValue = propertyValue;
  if (window?.start?.settings?.cleanse_all_whitespaces_for_expiry_date && newCardProperty === 'expiryDate') {
    formattedValue = formattedValue.replace(/\s/g, '');
    formattedValue = formattedValue.replace(/&nbsp;/g, '');
    formattedValue = formattedValue.trim();
  }
  return {type: types.UPDATE_NEW_CARD_DETAILS, newCardProperty, propertyValue: formattedValue};
};

export const updateCV2Details = (cv2Property, propertyValue) => ({
  type: types.UPDATE_CV2_DETAILS,
  cv2Property,
  propertyValue,
});

export const setCreditZeroOrder = zeroOrderReason => ({
  type: types.SET_CREDIT_ZERO_ORDER,
  zeroOrderReason,
});

export const updateKlarnaDetails = (klarnaProperty, propertyValue) => ({
  type: types.UPDATE_KLARNA_DETAILS,
  klarnaProperty,
  propertyValue,
});

export const setPaymentOptionIndex = index => ({
  type: types.SET_PAYMENT_OPTION_INDEX,
  paymentOptionIndex: index,
});

export const setSelectedSubPaymentOptionIndex = (paymentOptionIndex, selectedSubPaymentOptionIndex) => ({
  type: types.SET_SUB_PAYMENT_OPTION_INDEX,
  paymentOptionIndex,
  selectedSubPaymentOptionIndex,
});

export const setGooglePayAvailable = () => ({
  type: types.SET_GOOGLE_AVAILABLE,
});

export const initialisePaymentOptions = () => (dispatch, getState) => {
  if (isApplePayInPaymentList(getState())) {
    const canMakePayments = window?.ApplePaySession?.canMakePayments();
    if (canMakePayments) {
      dispatch(setApplePayAvailable());
    }
  }
  
  if (isGooglePayInPaymentsOptionList(getState())) {
    DomUtils.addScript('https://pay.google.com/gp/p/js/pay.js')
      .then(() => dispatch(onGooglePayLoaded()))
      .then(() => dispatch(setGooglePayAvailable()))
      .catch(() => {
      });
  }
};
